import { render, staticRenderFns } from "./CreateNewEmailTemplateAction.vue?vue&type=template&id=1d6fc8fe"
import script from "./CreateNewEmailTemplateAction.vue?vue&type=script&lang=js"
export * from "./CreateNewEmailTemplateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports